module.exports = __webpack_public_path__ + "assets/img/item1-info.3c9c4d71.png";